import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: null | ReactNode;
  when: boolean;
}

/**
 * A simple wrapper to handle conditional rendering with below benefits
 *
 * - Higher readability
 * - Prevent using && operator issue if condition is 0 or []
 *
 * @see https://www.youtube.com/watch?v=Rr5AqASIyxw
 */
export function Show({ children, fallback = null, when }: Props) {
  return when ? children : fallback;
}
